// src/lib/api.js

import axios from "axios";

const api = axios.create({
    // baseURL: process.env.REACT_APP_API_URL,
    baseURL:process.env.REACT_APP_API_URL,
    headers: {
        Accept: "application/json",
    },
});

export default api;